export default "__VITE_ASSET__Dyug5S6e__"